import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {Translation} from "react-i18next";

import {connect} from 'react-redux';
import {
  fetchLinksList,
  addLink,
  clearAddLink,
} from 'redux/links/actions';

import CommonPopup from 'components/common/CommonPopup';
import CommonMessage from 'components/common/CommonMessage';

import './AddHeader.css';


const AddHeader = props => {
  const {
    fetchLinksList,
    addLink,
    clearAddLink,
    addLinkSuccess,
    addLinkError,
    reset,
  } = props;

  useEffect(() => {
    return () => {
      clearAddLink();
    };
  }, []);

  useEffect(() => {
    fetchLinksList();
  }, [addLinkSuccess]);

  const handleAction = values => {
    addLink(null, true);
    clearAddLink();
  };

  return (
    <Translation>
      {(t) => (
        <div className="add-header__component">
          <div className="action-container">
            <span className="action" onClick={handleAction}>{t("Add Header")}</span>
            <CommonPopup
              questionIcon
              type="info"
            >
              {t("Clearly group your links")}
            </CommonPopup>
          </div>
        </div>
      )}
    </Translation>
  );
};

AddHeader.propTypes = {
  fetchLinksList: PropTypes.func.isRequired,
  addLink: PropTypes.func.isRequired,
  clearAddLink: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
  addLinkSuccess: PropTypes.bool,
  addLinkError: PropTypes.object,
};

AddHeader.defaultProps = {
  addLinkSuccess: null,
  addLinkError: null,
};

const mapStateToProps = (state) => {
  return {
    addLinkSuccess: state.linksReducer.addLinkSuccess,
    addLinkError: state.linksReducer.addLinkError,
  };
};

export default connect(
  mapStateToProps,
  {
    fetchLinksList,
    addLink,
    clearAddLink,
  },
)(AddHeader);
